function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#3D99DD"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M36.0324 16.087C35.8761 16.087 35.7199 16.0245 35.6011 15.9057L34.0885 14.393C33.8509 14.1555 33.8509 13.768 34.0885 13.5242C34.326 13.2804 34.7135 13.2867 34.9573 13.5242L36.4699 15.0369C36.7075 15.2744 36.7075 15.6619 36.4699 15.9057C36.3449 16.0307 36.1887 16.087 36.0324 16.087Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.474 36.6454C15.3177 36.6454 15.1615 36.5829 15.0427 36.4641L13.5363 34.9515C13.2988 34.7139 13.2988 34.3264 13.5363 34.0826C13.7738 33.8451 14.1614 33.8451 14.4051 34.0826L15.9115 35.5953C16.1491 35.8328 16.1491 36.2203 15.9115 36.4641C15.7865 36.5891 15.6303 36.6454 15.474 36.6454Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.8065 28.4195C27.6503 28.4195 27.494 28.357 27.3752 28.2382L21.7622 22.6251C21.5246 22.3876 21.5246 22.0001 21.7622 21.7563C21.9997 21.5188 22.3872 21.5188 22.631 21.7563L28.2441 27.3694C28.4816 27.6069 28.4816 27.9944 28.2441 28.2382C28.1191 28.357 27.9628 28.4195 27.8065 28.4195Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.2438 29.9572C25.0875 29.9572 24.9312 29.8947 24.8125 29.7759L20.2245 25.188C19.987 24.9504 19.987 24.5629 20.2245 24.3191C20.462 24.0816 20.8496 24.0816 21.0933 24.3191L25.6813 28.9071C25.9188 29.1446 25.9188 29.5322 25.6813 29.7759C25.5563 29.8947 25.4 29.9572 25.2438 29.9572Z",
  fill: "white"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.3442 25.8567C29.1879 25.8567 29.0317 25.7942 28.9129 25.6755L24.3249 21.0875C24.0874 20.85 24.0874 20.4624 24.3249 20.2187C24.5625 19.9811 24.95 19.9811 25.1938 20.2187L29.7818 24.8066C30.0193 25.0442 30.0193 25.4317 29.7818 25.6755C29.6567 25.7942 29.5005 25.8567 29.3442 25.8567Z",
  fill: "white"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.5304 40.002C16.2929 40.002 16.0616 39.9145 15.8803 39.7332C15.524 39.3769 15.524 38.7956 15.8803 38.4331C18.3743 35.939 17.918 32.9387 17.4367 29.7571C16.9304 26.4255 16.3616 22.6502 19.5057 19.5061C22.656 16.362 26.4252 16.9308 29.7568 17.4371C32.9383 17.9184 35.9449 18.3747 38.4327 15.8807C38.789 15.5244 39.3703 15.5244 39.7328 15.8807C40.0891 16.237 40.0891 16.8183 39.7328 17.1808C36.5825 20.3312 32.8133 19.7561 29.4817 19.2498C26.3001 18.7685 23.2936 18.3122 20.8058 20.8062C18.3118 23.3002 18.7681 26.3005 19.2494 29.4821C19.7557 32.8137 20.3245 36.5891 17.1804 39.7332C16.9992 39.9145 16.7617 40.002 16.5304 40.002Z",
  fill: "white"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.9173 34.3885C10.6798 34.3885 10.4485 34.301 10.2672 34.1197C9.91093 33.7634 9.91093 33.1821 10.2672 32.8196C13.4175 29.6692 17.1929 30.2443 20.5183 30.7506C23.6999 31.2319 26.7064 31.6882 29.1942 29.1942C31.6882 26.7002 31.2319 23.6999 30.7506 20.5183C30.2443 17.1867 29.6755 13.4113 32.8196 10.2672C33.1758 9.91093 33.7572 9.91093 34.1197 10.2672C34.476 10.6235 34.476 11.2048 34.1197 11.5674C31.6257 14.0614 32.082 17.0617 32.5633 20.2433C33.0696 23.5749 33.6384 27.3502 30.4943 30.4943C27.344 33.6447 23.5749 33.0696 20.2433 32.5633C17.0617 32.082 14.0551 31.6257 11.5674 34.1197C11.3861 34.301 11.1548 34.3885 10.9173 34.3885Z",
  fill: "white"
});

var SvgGeneralEthnicity = function SvgGeneralEthnicity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGeneralEthnicity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/general_ethnicity.f36bd590.svg";
export { ForwardRef as ReactComponent };